import React, { useContext, useEffect, useState } from 'react'

//context
import { OrgSettingsContext } from '@/context/OrgSettings';

//interfaces
import { DropdownGroupInfo, IBasicGroup} from  '@/interfaces/orgSettings';
import { IconLibrary } from  '@/interfaces/IconLibrary';

//helpers
import { Truncate } from  '@/helpers/Text';

//components
import Icon from  '@/components/elements/icons/Icons';

//api
import { getGroupListForUser } from '@/api/orgSettings/users';



const UseUserRolePermissions = (userId, userWorkspaceId) => {  
    const {appId} = useContext(OrgSettingsContext);
    const [groups, setGroups] = useState<DropdownGroupInfo[]>();
    const [groupsData, setGroupsData] = useState(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [displayTooltip, setDisplayTooltip] = useState<boolean>(false);
    const [extraDetailText, setExtraDetailText] = useState<string>("");
    const maxRecordsToDisplay = 6;

    useEffect(() => {
        if (userId && displayTooltip) {
            getUsersGroupData();        
        }
    }, [displayTooltip])

    useEffect(() => {
        if (groupsData?.length > 0) {
            const newGroups: DropdownGroupInfo[] = groupsData.map((userGroup) => ({
                title: Truncate(userGroup.name, 18),
                subtitle: userGroup.permission === "manage" ? "Editor" : "Viewer",
                displayIcon: true,
                icon: <Icon iconName={IconLibrary.USERS} sizeInPx="18" color="#343D4C" />,
            }));
            setGroups(newGroups);
        }
        setIsLoading(false);
    }, [groupsData]);

    function getUsersGroupData() {
        if (!appId && !userWorkspaceId) { return }
        
        setIsLoading(true);
        getGroupListForUser(appId || userWorkspaceId, userId)
        .then(({records, total}: IBasicGroup) => {
            const recordsToDisplay = records.slice(0, maxRecordsToDisplay);
            setGroupsData(recordsToDisplay);
            if (total > maxRecordsToDisplay) {
                setExtraDetailText(`+${total - maxRecordsToDisplay} more ${total - maxRecordsToDisplay > 1 ? "groups" : "group"}`);
            } else {
                setExtraDetailText('');
            }       
        })
        .catch((error) => {
            console.error("Issue getting user groups data", error)
        });
    }

    return{isLoading, groups, displayTooltip, setDisplayTooltip, extraDetailText}
}

export default UseUserRolePermissions